import { isMentionAutocompleteCategory } from "./types"

export type GhostMentionCandidate = {
  category: string
  label: string
  pinned?: boolean
}

/** Лейбл для матчинга: без ведущего @ (у reference часто `@reference_N`). */
export function mentionMatchLabel(item: GhostMentionCandidate): string {
  const label = item.label.trim()
  return label.startsWith("@") ? label.slice(1) : label
}

/** Выбор одного кандидата для ghost: exact → pinned → shortest → localeCompare. */
export function findGhostMentionMatch<T extends GhostMentionCandidate>(prefix: string, items: T[]): T | null {
  if (prefix.length < 2) return null
  const q = prefix.toLowerCase()
  const candidates = items.filter((it) => {
    if (!isMentionAutocompleteCategory(it.category)) return false
    const label = mentionMatchLabel(it)
    return label.length >= prefix.length && label.toLowerCase().startsWith(q)
  })
  if (candidates.length === 0) return null
  candidates.sort((a, b) => {
    const la = mentionMatchLabel(a)
    const lb = mentionMatchLabel(b)
    const aExact = la.toLowerCase() === q
    const bExact = lb.toLowerCase() === q
    if (aExact !== bExact) return aExact ? -1 : 1
    if (Boolean(a.pinned) !== Boolean(b.pinned)) return a.pinned ? -1 : 1
    if (la.length !== lb.length) return la.length - lb.length
    return la.localeCompare(lb, undefined, { sensitivity: "base" })
  })
  return candidates[0] ?? null
}
